import { CALENDAR_CONSTANTS } from "src/constants/calander.Constants";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export const getOfficeJobProCalander = async (
  payload: { [key: string]: string | number | number[] } | undefined,
  selectedType: string
) => {
  let apiUrl;
  switch (selectedType) {
    case CALENDAR_CONSTANTS.CALANDER_TYPES_OPTIONS.OFFICE:
      apiUrl = API_URL.JOB_CALANDER.GET_OFFICE_CALANDER;
      break;
    case CALENDAR_CONSTANTS.CALANDER_TYPES_OPTIONS.JOBS:
      apiUrl = API_URL.JOB_CALANDER.GET_JOB_CALANDER;
      break;
    case CALENDAR_CONSTANTS.CALANDER_TYPES_OPTIONS.PROFESSIONAL:
      apiUrl = API_URL.JOB_CALANDER.GET_PROFESSIONAL_CALANDER;
      break;
    default:
      apiUrl = API_URL.JOB_CALANDER.GET_OFFICE_CALANDER;
  }

  const res = await apiCall.get(apiUrl, payload);
  return await handleResponse(res);
};
